<template>
  <card no-header no-footer no-padding>
    <div slot="card-body">
      <l-map id="endDeviceMap" :markers="mapPositions">
        <!-- manual position -->
        <l-cluster :markers="manualPosition"
                   :popup="true"
                   :popup-content="getEndpointPopupContent(true)"
                   :popup-data="endDevicePopupAttributes"
                   icon="end-device"
                   :marker-color="() => 'blue'"
        />
        <!-- gateway position -->
        <l-cluster :markers="gateways"
                   :popup="true"
                   :popup-data="['eui']"
                   icon="gateway"
                   popup-content="<a href='#/gateways/$0'>$0</a>"
        />
      </l-map>

      <table id="endDeviceGeolocation" class="table table-sm table-ellipsis mb-0">
        <tbody>
          <tr>
            <td class="text-uppercase">{{ $t('ed-geolocation:type') }}</td>
            <td>{{ geolocation | capitalize }}</td>
          </tr>
          <tr v-if="endDevice.geolocation==='MANUAL'">
            <td class="text-uppercase">{{ $t('ed-geolocation:latitude') }}</td>
            <td>{{ endDevice.latitude !== null ? endDevice.latitude : '-' | coordinates }}</td>
          </tr>
          <tr v-if="endDevice.geolocation==='MANUAL'">
            <td class="text-uppercase">{{ $t('ed-geolocation:longitude') }}</td>
            <td>{{ endDevice.longitude !== null ? endDevice.longitude : '-' | coordinates }}</td>
          </tr>
          <tr v-if="endDevice.geolocation==='MANUAL'">
            <td class="text-uppercase">{{ $t('ed-geolocation:altitude') }}</td>
            <td>{{ endDevice.altitude !== null ? endDevice.altitude : '-' | number('0,0.[00]','',' m') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </card>
</template>

<script>
import { upperFirst, isEmpty } from 'lodash-es'
import to from '@/modules/await-to-js'
import formatDate from 'vue-kerlink/dist/filters/date'

export default {
  props: {
    endDevice: {
      type: Object,
      required: true
    },
    cluster: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      gateways: []
    }
  },

  computed: {
    manualPosition () {
      return this.endDevice.geolocation === 'MANUAL' ? [{ coordinates: [this.endDevice.longitude, this.endDevice.latitude, this.endDevice.altitude] }] : []
    },

    mapPositions () {
      return [...this.manualPosition, ...this.gateways]
    },

    endDevicePopupAttributes () {
      return [
        { attr: 'timestamp', formatter: formatDate },
        { attr: 'algorithm' },
        { attr: 'coordinates', index: 1 },
        { attr: 'coordinates', index: 0 },
        { attr: 'coordinates', index: 2 }
      ]
    },

    geolocation () {
      if (this.endDevice.geolocation === 'INHERITED') {
        return this.$t('ed-geolocation:inherited') + ' (' + (this.cluster.geolocEnabled ? this.$t('ed-geolocation:enabled') : this.$t('ed-geolocation:disabled')) + ')'
      }

      return this.$t('ed-geolocation:manual')
    }
  },

  watch: {
    endDevice () {
      this.getGateways()
    }
  },

  created () {
    this.getGateways()
  },

  methods: {
    getEndpointPopupContent (manual) {
      const dateLabel = upperFirst(this.$t('ed-map:date'))
      const algorithmLabel = upperFirst(this.$t('ed-map:algorithm'))
      const latLabel = upperFirst(this.$t('ed-map:latitude'))
      const longLabel = upperFirst(this.$t('ed-map:longitude'))
      const altLabel = upperFirst(this.$t('ed-map:altitude'))

      let content = manual ? '' : `<strong>${dateLabel}:</strong> $0<br>`
      content += manual ? '' : `<strong>${algorithmLabel}:</strong> $1<br>`
      content += `<strong>${latLabel}:</strong> $2°<br>
      <strong>${longLabel}:</strong> $3°<br>
      <strong>${altLabel}:</strong> $4 m`
      return content
    },

    async getGateways (options = {}) {
      if (isEmpty(this.endDevice)) return

      let error, response
      [error, response] = await to(this.$api.getEndDeviceLastGateways(this.endDevice, { page: 1, pageSize: 200 }))
      if (error || !response) return

      this.gateways = response.data.count > 0 ? response.data.list : []
    }
  }
}
</script>

<style scoped lang="scss">
  #endDeviceMap {
    height: 400px;
  }
</style>
